import { render } from "./AnnualInannualInspectionChart.vue?vue&type=template&id=10ad4680"
import script from "./AnnualInannualInspectionChart.vue?vue&type=script&lang=js"
export * from "./AnnualInannualInspectionChart.vue?vue&type=script&lang=js"

import "./AnnualInannualInspectionChart.vue?vue&type=style&index=0&id=10ad4680&lang=scss"

import exportComponent from "/Users/user/Desktop/prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__